// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selectize-control.multi {\n  width: 100%;\n  display: block;\n}\n.selectize-control.multi .selectize-input > div.active {\n  background: #efefef;\n  color: #333333;\n  border: 0 solid rgba(0, 0, 0, 0);\n}", ""]);
// Exports
module.exports = exports;
